import React, { useCallback } from 'react';
import './PayNow.scss';
import LinkProvider from '../../CommonComponents/LinkProvider/LinkProvider';
import getSetCookie from '../../cookie';
import { withRouter } from 'react-router';

function PayNow(props) {
  const {
    view,
    order: { type, id, lkCountry },
    email,
    payNow: { header = '', description = '' } = {},
    listing,
    dataLocale: { PAY_NOW },
    localeInfo,
  } = props;
  const { countryCode } = localeInfo;
  const { domain } = localeInfo;
  // const newArch = getSetCookie.getCookie('newArch');

  const paymentLink =
    type !== 'HEC'
      ? `/checkout/onepage/retrypayment?oid=${window.btoa(id.toString())}&eid=${window.btoa(email)}`
      : `${domain}/pmd/payuindex.php?oid=${window.btoa(id.toString())}`;
  const fireGA = useCallback(() => {
    const trackEnv = view === 'desktop' ? 'dtm' : 'mobileGA';
    getSetCookie.setCookie('orderId', id, 0.0625);
    if (window[trackEnv].LenskartRewamp) {
      window[trackEnv].LenskartRewamp.myaccount?.myOrderStatusEventsClick(listing, 'pay now');
    }
    if (getSetCookie.getCookie('isReturnExOld')) {
      getSetCookie.deleteCookie('isReturnExOld');
    }
    // if (newArch) {
    window.location.href = paymentLink;
    // } else {
    // props.history.push(paymentLink);
    // }
  }, []);

  if (lkCountry?.toLowerCase() !== countryCode?.toLowerCase()) return null;

  return (
    <div
      className={`order-pay-now bora-8 justify-space-between align-items-center display-flex ${
        view === 'desktop'
          ? 'desktop padding-12 bg-color-white margin-t10 margin-b15 margin-l20 margin-r20'
          : 'mr-t10 bg-color_white pd-12'
      }`}
    >
      <div className={`${view === 'desktop' ? 'flex-basis-80' : 'flex-basis-76'}`}>
        <div
          className={`${
            view === 'desktop' ? 'text-color-33 fs16' : 'text-color_grey_black fsp12'
          } fw700`}
        >
          {header}
        </div>
        <div
          className={`${
            view === 'desktop' ? 'text-color-33 fs14' : 'text-color_grey_black fsp12'
          } lh-14`}
        >
          {description}
        </div>
      </div>
      <LinkProvider
        className={`${
          view === 'desktop'
            ? 'fs14 padding-t10 padding-b10 text-color-white bg-color-primary no-decoration flex-basis-20'
            : 'pd-t8 pd-b8 bg-color_link_blue text-color_white flex-basis-24'
        } text-center block bora-4 fw700 text-uppercase`}
        // to={paymentLink}
        onClick={fireGA}
      >
        {PAY_NOW}
      </LinkProvider>
    </div>
  );
}

export default withRouter(PayNow);
